



































import Vue from "vue";

const status = [
  {
    label: "有状态负载",
    error: 0,
    normal: 0
  },
  {
    label: "无状态负载",
    error: 0,
    normal: 0
  },
  {
    label: "任务",
    error: 0,
    normal: 0
  },
  {
    label: "定时任务",
    error: 0,
    normal: 0
  }
];
export default Vue.extend({
  name: "StatusCard",
  data() {
    return {
      status
    };
  },
  methods: {
    getPercent(item: { error: number; normal: number }) {
      if (item.error + item.normal === 0) return 0;
      return parseFloat(
        ((item.normal * 100) / (item.error + item.normal)).toFixed(2)
      );
    },
    setChart(data: any[]) {
      data.forEach((item, index) => {
        this.status[index].normal = item[0].value;
        this.status[index].error = item[1].value;
      });
    }
  }
});
